export const roleTours = {
    // administrator: [
    //     {
    //         id: 'admin-dashboard-overview',
    //         title: 'Admin Dashboard Overview',
    //         auto: false,
    //         match: () => document.body.classList.contains('page-template-dashboard-template'),
    //         steps: [
    //             {
    //                 element: '#header nav',
    //                 popover: {
    //                     title: 'Navigation',
    //                     description: 'Use the sidebar to switch between dashboard sections.',
    //                 },
    //             },
    //             {
    //                 element: '.content_head .title h1',
    //                 popover: {
    //                     title: 'Dashboard',
    //                     description: 'This area shows your current role-specific overview.',
    //                 },
    //             },
    //             {
    //                 element: '.notifications',
    //                 popover: {
    //                     title: 'Notifications',
    //                     description: 'Open notifications to see updates from requests and workflow actions.',
    //                 },
    //             },
    //         ],
    //     },
    // ],
    // roi_specialist: [
    //     {
    //         id: 'roi-dashboard-overview',
    //         title: 'ROI Dashboard Overview',
    //         auto: false,
    //         match: () => document.body.classList.contains('page-template-dashboard-template'),
    //         steps: [
    //             {
    //                 element: '.roi-kpis',
    //                 popover: {
    //                     title: 'Key metrics',
    //                     description: 'Track request volumes and escalation counts at a glance.',
    //                 },
    //             },
    //             {
    //                 element: '.roi-panel--wide',
    //                 popover: {
    //                     title: 'Escalated and urgent',
    //                     description: 'Prioritize these requests first for faster turnaround.',
    //                 },
    //             },
    //             {
    //                 element: '.notifications',
    //                 popover: {
    //                     title: 'Alerts',
    //                     description: 'Use notifications for quick follow-ups and updates.',
    //                 },
    //             },
    //         ],
    //     },
    // ],
    case_manager: [
        {
            id: 'case-manager-requests-overview',
            title: 'How to manage submissions and requests',
            auto: false,
            match: () => document.body.classList.contains('page-template-dashboard-template'),
            steps: [
                {
                    element: '.search-field',
                    popover: {
                        title: 'Search',
                        description: 'Search submissions and requests by patient or identifier.',
                    },
                },
                {
                    element: '#filters',
                    popover: {
                        title: 'Advanced filters',
                        description: 'Filter by month, year, and activity window.',
                    },
                },
                {
                    element: '.case-manager-status-filters',
                    popover: {
                        title: 'Status tabs',
                        description: 'Quickly scope results by processing stage.',
                    },
                },
                {
                    element: '.case-manager-requests-table-wrapper',
                    popover: {
                        title: 'Submissions and requests',
                        description: 'Expand a submission to review all linked requests.',
                    },
                },
                {
                    element: '.ca-expand-btn',
                    deferUntilVisible: true,
                    popover: {
                        title: 'Expand a submission',
                        description: 'Click List of requests to expand a submission. Press Next to open it in the tour.',
                    },
                },
                {
                    element: '.ca-expanded-row',
                    deferUntilVisible: true,
                    expandFromSelector: '.ca-expand-btn',
                    popover: {
                        title: 'Expanded requests',
                        description: 'After expanding, all requests linked to this submission appear in this panel.',
                    },
                },
                {
                    element: '.case-manager-view-request',
                    deferUntilVisible: true,
                    viewInExpandedSelector: '.case-manager-view-request',
                    popover: {
                        title: 'View request',
                        description: 'Click View to open request details and review status, files, and activity.',
                    },
                },
            ],
        },
        {
            id: 'case-manager-add-request-open-tour',
            title: 'How to create a request',
            auto: false,
            match: () => document.body.classList.contains('page-template-dashboard-template'),
            launch: {
                type: 'redirect',
                to: '/add-new-request/',
                tourId: 'case-manager-add-request-create',
            },
        },
        {
            id: 'case-manager-add-request-create',
            title: 'How to create a request',
            auto: false,
            match: () => window.location.pathname.replace(/\/+$/, '') === '/add-new-request',
            steps: [
                {
                    element: '#add-request-form',
                    popover: {
                        title: 'Create request form',
                        description: 'This page is where you fill patient and facility details for a new request.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(1)',
                    popover: {
                        title: 'Patient name',
                        description: 'Complete correct patient name to create a new request.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(2)',
                    popover: {
                        title: 'Patient date of birth',
                        description: 'Complete correct patient date of birth to create a new request.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(3)',
                    popover: {
                        title: 'Patient SSN',
                        description: 'Complete correct patient SSN to create a new request. (Last four or respond with "NA")',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(4)',
                    popover: {
                        title: 'Patient address',
                        description: 'Complete correct patient address to create a new request.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(5)',
                    popover: {
                        title: 'Mediation date',
                        description: 'Complete correct mediation date to create a new request.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(6)',
                    popover: {
                        title: 'Treatment dates',
                        description: 'Complete correct treatment dates to create a new request.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(7)',
                    popover: {
                        title: 'Facilities',
                        description: 'Use search field to find a facility from the website and add it to the request. If not found, you will be able to enter it manually.<br>You can add multiple records of the same facility to the request.<br>You can also add a custom facility by clicking on the "Add More Facilities" button.',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(8)',
                    popover: {
                        title: 'Photo identification',
                        description: 'Upload a photo identification of the patient to create a new request. (State issued ID, passport, etc.)',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(9)',
                    popover: {
                        title: 'Docuswift authorization',
                        description: 'Upload a Docuswift authorization of the patient to create a new request. (Docuswift Pro, LLC\'s Authorization to Disclose PHI signed by patient)',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(10)',
                    popover: {
                        title: 'Reproductive attestation',
                        description: 'Upload a reproductive attestation of the patient to create a new request. (Reproductive Attestation)',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(11)',
                    popover: {
                        title: 'Letter of Representation on your letterhead',
                        description: 'Upload a letter of representation on your letterhead to create a new request. (Letter of Representation on your letterhead)',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(12)',
                    popover: {
                        title: 'Copy of affidavit',
                        description: 'Upload a copy of the affidavit to create a new request. (Copy of affidavit)',
                    },
                },
                {
                    element: '#add-request-form .form-section:nth-of-type(13)',
                    popover: {
                        title: 'Expedited Records Request',
                        description: 'Check the Expedited Records Request checkbox to create a new request. When checked, the request will be expedited and will be processed with a Rush label.',
                    },
                },
                {
                    element: '#add-request-form input[type="submit"]',
                    popover: {
                        title: 'Submit request',
                        description: 'Click Submit to create the request and return to dashboard.',
                    },
                },
            ],
        },
        {
            id: 'case-manager-request-details-overview',
            title: 'How to review request details',
            auto: false,
            match: () => document.body.classList.contains('page-template-dashboard-template'),
            steps: [
                {
                    element: '.ca-expand-btn',
                    deferUntilVisible: true,
                    popover: {
                        title: 'Open request list',
                        description: 'Use List of requests to show requests inside a submission.',
                    },
                },
                {
                    element: '.ca-expanded-row',
                    deferUntilVisible: true,
                    expandFromSelector: '.ca-expand-btn',
                    popover: {
                        title: 'Nested request rows',
                        description: 'This list contains each request linked to the selected submission.',
                    },
                },
                {
                    element: '.case-manager-view-request',
                    deferUntilVisible: true,
                    viewInExpandedSelector: '.case-manager-view-request',
                    popover: {
                        title: 'Open details',
                        description: 'Press Next and the tour will open this request details panel.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    openDetailsFromSelector: '.case-manager-view-request',
                    detailsPanelSelector: '#cm_request_detail',
                    popover: {
                        title: 'Request details panel',
                        description: 'The full request overview opens here with workflow and file information.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail .request_details_header',
                    popover: {
                        title: 'Header',
                        description: 'Top header shows DSPro ID, escalated/rush badges, and request status progress.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail .request_details_main .details_box .request_additional_container:not(.header_container):not(.case_manager_summary)',
                    popover: {
                        title: 'Request information',
                        description: 'This block shows core request info such as type, facility, and created date.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail .request_details_main .details_box .request_additional_container.header_container',
                    popover: {
                        title: 'Request summary',
                        description: 'This summary shows current status plus Next Update, Days Open, and Days Remaining.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail .request_details_main .details_box .case_manager_action_container',
                    popover: {
                        title: 'Case manager action',
                        description: 'This block shows what you should do now: no action, CM review, invoice payment, or records download.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail .details_box.inline',
                    popover: {
                        title: 'Section filters',
                        description: 'Use tabs (All, Notes, Files, Payments) to quickly focus on one part of request details.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail #activities_box',
                    popover: {
                        title: 'Activity and notes',
                        description: 'Timeline of request changes and team notes. Add a note here to keep communication in one place.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail #files_box',
                    popover: {
                        title: 'Files',
                        description: 'All request files live here: preview, download, upload, and file actions when available.',
                    },
                },
                {
                    element: '#cm_request_detail',
                    detailElementSelector: '#cm_request_detail #payments_box',
                    popover: {
                        title: 'Payments',
                        description: 'Payment history and invoice-related details for this request appear in this section.',
                    },
                },
                {
                    element: '.sidebar_details_box',
                    popover: {
                        title: 'Sidebar details',
                        description: 'Right sidebar contains sub-status/actions, facility and department details, patient data, assignments, and TAT widget.',
                    },
                },
            ],
        },
    ],
    company_admin: [
        {
            id: 'company-admin-requests-overview',
            title: 'How to manage submissions and requests',
            auto: false,
            match: () => document.body.classList.contains('page-template-dashboard-template'),
            steps: [
                {
                    element: '.search-field',
                    popover: {
                        title: 'Search',
                        description: 'Find submissions by patient name or keywords.',
                    },
                },
                {
                    element: '#filters',
                    popover: {
                        title: 'Advanced filters',
                        description: 'Filter requests by month, year, case manager, and last changes.',
                    },
                },
                {
                    element: '.company-admin-status-filters',
                    popover: {
                        title: 'Status tabs',
                        description: 'Switch between active queues like payment/download readiness.',
                    },
                },
                {
                    element: '.company-admin-requests-table-wrapper',
                    popover: {
                        title: 'Submissions and requests',
                        description: 'Expand a submission to review all linked requests.',
                    },
                },
                {
                    element: '.ca-expand-btn',
                    deferUntilVisible: true,
                    popover: {
                        title: 'Expand a submission',
                        description: 'Click List of requests to expand a submission. Press Next to open it in the tour.',
                    },
                },
                {
                    element: '.ca-expanded-row',
                    deferUntilVisible: true,
                    expandFromSelector: '.ca-expand-btn',
                    popover: {
                        title: 'Expanded requests',
                        description: 'After expanding, all requests linked to this submission appear in this panel.',
                    },
                },
                {
                    element: '.company-admin-view-request',
                    deferUntilVisible: true,
                    viewInExpandedSelector: '.company-admin-view-request',
                    popover: {
                        title: 'View request',
                        description: 'Click View to open request details and review status, files, and activity.',
                    },
                },
            ],
        },
        {
            id: 'company-admin-case-managers-open-tour',
            title: 'How to add a case manager',
            auto: false,
            match: () => document.body.classList.contains('page-template-dashboard-template'),
            launch: {
                type: 'redirect',
                to: () => window?.docuswiftPortal?.case_managers_page_url || '/case-managers/',
                tourId: 'company-admin-case-managers-management',
            },
        },
        {
            id: 'company-admin-case-managers-management',
            title: 'How to add a case manager',
            auto: false,
            match: () => document.body.classList.contains('page-template-page-case-managers'),
            steps: [
                {
                    element: '#add_case_manager',
                    popover: {
                        title: 'Add Case Manager',
                        description: 'Start here to invite a new case manager to your company.',
                    },
                },
                {
                    element: '#add_case_manager_modal .modal_content',
                    openModal: '#add_case_manager_modal',
                    popover: {
                        title: 'Invite popup',
                        description: 'In this popup, you can enter the case manager\'s email and full name, then click Send Invite to invite them to your company.',
                    },
                },
                {
                    element: '#add-case-manager-form',
                    keepModal: '#add_case_manager_modal',
                    popover: {
                        title: 'Invite form fields',
                        description: 'Enter the case manager email and full name, then click Send Invite. Use Cancel to close without sending.',
                    },
                },
                {
                    element: '#case_managers',
                    closeModal: true,
                    popover: {
                        title: 'You are all set',
                        description: 'After sending an invite, the new case manager appears in this table with their submissions and request totals.',
                    },
                },
            ],
        },
    ],
};

